let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4SKbF")).then(() => parcelRequire('hVJCF'));